export default __webpack_public_path__ + "static/media/alert-icon.ffdcd543.svg";